module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch00_fm05_ded"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("This book is dedicated to the greatest salesman who ever lived.")]), _vm._v(" He was a man who could change a mind in a heartbeat, with the skill of a surgeon. What I learned, I learned from him, and what I write, I write for him. Xerox taught me how, but he taught me why. He was my father. Rest easy, Lion Lee Jolles; your voice and words will never be forgotten."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e19643c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_ded.vue
// module id = 69
// module chunks = 0